var documentInit;

(function ($) {

	documentInit = function () {
		new Document();
	}

	class Document {
		constructor() {
			this.init();
			this.bind();
		}

		init() {
			this.$body = $(document.body);

			document.headerHeightScrolled = 100;
		}

		bind() {
			$(window).scroll((e) => { this.scroll(); });
			$(window).on('resize', this.setVw);
		}

		scroll() {

			var scroll = window.scrollY;

			if (scroll > 0 && !this.$body.hasClass('is-scrolled')) {
				this.$body.addClass('is-scrolled');
				return;
			}

			if (scroll == 0 && this.$body.hasClass('is-scrolled')) {
				this.$body.removeClass('is-scrolled');
				return;
			}

		}

		setVw() {
			let vw = document.documentElement.clientWidth / 100;
			document.documentElement.style.setProperty('--vw', `${vw}px`);
		}

	}

})(jQuery);

export default documentInit;